// Module
var code = "<div class=\"media-wrapper photo clearfix\"> <div class=\"photo-gallery\"> <a ng-repeat=\"item in ::ctrl.sItem.children\" data-gallery=\"example-gallery4\" data-toggle=\"lightbox\" style=\"background:url('{{::item.imageM.href}}') center center no-repeat!important\" ng-click=\"ctrl.openImageGallery(item)\"> </a> </div> </div> ";
// Exports
module.exports = code;